import {
  useClosePurchaseOrderPreviewMutation,
  useClosePurchaseOrdersMutation,
} from "../../../store/apiSlice/purchaseOrderApiSlice";
import { CloseDocumentModal } from "../../shared/closeDocument/CloseDocumentModal";

/**
 * Confirm closing purchase orders with preview blockers and warnings.
 */
export const ClosePurchaseOrderModal = ({ closeModal, orders = [], setSelectedOrder }) => (
  <CloseDocumentModal
    closeModal={closeModal}
    orders={orders}
    setSelectedOrder={setSelectedOrder}
    title="Close purchase order"
    submitLabel="Close order"
    nounSingular="purchase order"
    nounPlural="purchase orders"
    idKey="purchase_order_id"
    usePreviewMutation={useClosePurchaseOrderPreviewMutation}
    useCloseMutation={useClosePurchaseOrdersMutation}
    previewErrorMessage="Could not load close preview."
    closeErrorMessage="Failed to close purchase orders."
  />
);
